import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import {
  navBar,
  mainBody,
  recentWork,
  leadership,
  skills,
  getInTouch,
  experiences,
} from "./editable-stuff/config.js";
import MainBody from "./components/home/MainBody";
import ForYou from "./components/home/ForYou";
import AutomationProcess from "./components/home/AutomationProcess";
import AutomationDetails from "./components/home/AutomationDetails";
import AboutSection from "./components/home/AboutSection";
import RecentWork from "./components/home/RecentWork";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Skills from "./components/home/Skills";
// import { Blog } from "./components/blog/Blog";
// import BlogPost from "./components/blog/BlogPost";
import GetInTouch from "./components/home/GetInTouch.jsx";
import Leadership from "./components/home/Leadership.jsx";

import Experience from "./components/home/Experience";

const resolveRouterBase = () => {
  // In local development, serve routes from root to avoid basename mismatches.
  if (
    typeof window !== "undefined" &&
    ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)
  ) {
    return "";
  }

  const publicUrl = process.env.PUBLIC_URL || "";
  if (!publicUrl) return "";

  try {
    const parsed = new URL(publicUrl, "http://localhost");
    return parsed.pathname.replace(/\/+$/, "");
  } catch {
    return publicUrl.replace(/\/+$/, "");
  }
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Home = React.forwardRef((props, ref) => {
  return (
    <>
      <MainBody
        gradient={mainBody.gradientColors}
        title={[mainBody.firstName, mainBody.middleName, mainBody.lastName]
          .filter(Boolean)
          .join(" ")}
        message={mainBody.message}
        icons={mainBody.icons}
        ref={ref}
      />
      <ForYou />
      {recentWork.show && (
        <RecentWork
          heading={recentWork.heading}
          subheading={recentWork.subheading}
          items={recentWork.items}
        />
      )}
      <AutomationProcess />
      <AboutSection />
      {experiences.show && <Experience experiences={experiences} />}
      {leadership.show && (
        <Leadership
          heading={leadership.heading}
          message={leadership.message}
          img={leadership.images}
          imageSize={leadership.imageSize}
        />
      )}
      {skills.show && (
        <Skills
          heading={skills.heading}
          hardSkills={skills.hardSkills}
          softSkills={skills.softSkills}
        />
      )}
    </>
  );
});

const App = () => {
  const titleRef = React.useRef();
  const basename = resolveRouterBase();
  const hasBase = Boolean(basename);

  return (
    <BrowserRouter basename={basename}>
      <ScrollToTop />
      {navBar.show && <Navbar ref={titleRef} />}
      <Routes>
        <Route
          path="/"
          element={
            hasBase ? <Home ref={titleRef} /> : <Navigate to="/home" replace />
          }
        />
        <Route
          path="/home"
          element={
            hasBase ? <Navigate to="/" replace /> : <Home ref={titleRef} />
          }
        />
        <Route path="/automation" element={<AutomationDetails />} />
      </Routes>
      {/* {false && <Route path="/blog" exact component={Blog} />}
      {false && <Route path="/blog/:id" component={BlogPost} />} */}
      <Footer>
        {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
        )}
      </Footer>
    </BrowserRouter>
  );
};

export default App;
